import { Routes } from '@angular/router';
import { RoleGuard } from './auth/guard/role-guard/role.guard';
import { canActivateGuard } from './auth/guard/auth-guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'Startseite',
    loadComponent: () =>
      import('./components/start_page/start-page/start-page.component').then(m => m.StartPageComponent),
    canActivate: [canActivateGuard]
  },
  {
    path: 'EB',
    loadComponent: () =>
      import('./components/confirmation/search/search-ticket/search-ticket.component').then(m => m.SearchTicketComponent),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'EB/:ticketNumber/1',
    loadComponent: () =>
      import('./components/confirmation/pages/choose-date/choose-date.component').then(m => m.ChooseDateComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'EB/:ticketNumber/2',
    loadComponent: () =>
      import('./components/confirmation/pages/choose-participant/choose-participant.component').then(m => m.ChooseParticipantComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'EB/:ticketNumber/3',
    loadComponent: () =>
      import('./components/confirmation/pages/edit-appointment-details/edit-appointment-details.component').then(m => m.EditAppointmentDetailsComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'EB/:ticketNumber/4',
    loadComponent: () =>
      import('./components/confirmation/pages/show-appointment-details/show-appointment-details.component').then(m => m.ShowAppointmentDetailsComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'EB/:ticketNumber/5',
    loadComponent: () =>
      import('./components/confirmation/pages/add-signature/add-signature.component').then(m => m.AddSignatureComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'PK',
    loadComponent: () =>
      import('./components/parking_ticket/search/search-parking-ticket/search-parking-ticket.component').then(m => m.SearchParkingTicketComponent),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'PK/:ticketNumber',
    loadComponent: () =>
      import('./components/parking_ticket/search/search-parking-ticket/search-parking-ticket.component').then(m => m.SearchParkingTicketComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'PK/:ticketNumber/1',
    loadComponent: () =>
      import('./components/parking_ticket/pages/upload-ticket/upload-ticket.component').then(m => m.UploadTicketComponent),
    canActivate: [RoleGuard,canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] },
  },
  {
    path: 'KK',
    loadComponent: () =>
      import('./components/health_insurance/search/search-customer/search-customer.component').then(m => m.SearchCustomerComponent),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'KK/:customerId',
    loadComponent: () =>
      import('./components/health_insurance/pages/show-details/show-details.component').then(m => m.ShowDetailsComponent),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Dolmetscher', 'Admin'] }
  },
  {
    path: 'Einsatzbestaetigungen-Verwaltung',
    loadComponent: () =>
      import('./components/dashboard/ticket-administration/ticket-administration.component').then(m => m.TicketAdministrationComponent),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Buero', 'Admin'] }
  },
  { path: '', redirectTo: '/Startseite', pathMatch: 'full' },
  { path: '**', redirectTo: '/Startseite' }
];